module.exports = __webpack_public_path__ + "static/media/layout.3801ca73.svg";